import { getConfig } from '@edx/frontend-platform';

import { useIntl } from '@edx/frontend-platform/i18n';
import messages from '../messages'; // Import the messages file

import React, { useState, useEffect } from 'react';
import ProgramCreationTable from '../Componentsadminpanel/ProgramCreationTable'; // import your table component

const ApprovalsPage = () => {
  const [data, setData] = useState([]);  // This will hold your table data
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [statusFilter, setStatusFilter] = useState(''); 
  const [selectedRows, setSelectedRows] = useState([]);  // Track selected rows here
  const [selectAll, setSelectAll] = useState(false);
  
  const baseUrl = getConfig().LMS_BASE_URL;
  console.log(`${baseUrl}/api/approvals ` , "Hello");
  // Fetch data from your API or database, based on page and search term
   const fetchData = async () => {
      const response = await fetch(`${getConfig().LMS_BASE_URL}/api/approvals?page=${page}&pageSize=${pageSize}&search=${searchTerm}`);
      const result = await response.json();
      setData(result.enrollments);
      setTotalCount(result.total_counts);
    };


  const { formatMessage } = useIntl();

  useEffect(() => {
    fetchData();
  }, [page, pageSize, searchTerm]);

//get csrf token
const getCsrfToken = () => {
    return document.cookie.split('; ')
        .find(row => row.startsWith('csrftoken='))
        ?.split('=')[1];
}

 
  const handleStatusChange = async () => {
    if (selectedRows.length === 0) {
      alert(formatMessage(messages.noRowSelected));
      return;
    }
    if (statusFilter === "") {
      alert(formatMessage(messages.selectStatusBeforeUpdate));
      return;
    }
    console.log(`${getConfig().LMS_BASE_URL}`,"urllll");
    const response = await fetch(`${getConfig().LMS_BASE_URL}/api/update-enrollment-status/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCsrfToken(), // Add csrf token here
      },
      credentials:'include',
      body: JSON.stringify({
        ids: selectedRows,
        status: statusFilter
      }),
    });

    if (response.ok) {
      alert(formatMessage(messages.statusUpdatedSuccessfully));
      // Fetch updated data
      fetchData();
      setSelectedRows([]);
      setStatusFilter(''); 
    } else {
      alert(formatMessage(messages.failedToUpdateStatus));
    }
  };

// Handle "Select All" toggle
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);  // Deselect all rows if Select All is unchecked
    } else {
      const allIds = data.map(row => row.id);  // Select all rows on the current page
      setSelectedRows(allIds);
    }
    setSelectAll(!selectAll);  // Toggle Select All state
  };

  // Check if all rows are selected
  useEffect(() => {
    if (data.length > 0 && selectedRows.length === data.length) {
      setSelectAll(true);  // If all rows are selected, check Select All
    } else {
      setSelectAll(false);  // Uncheck Select All if not all rows are selected
    }
  }, [selectedRows, data]);

  return (
    <div>
      {/* Title */}
      <h1>{formatMessage(messages.layoutApprovals)}</h1>
  
      {/* Dropdown for Status Filter */}
      <div className="status-filter-container">
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="" disabled selected>
            {formatMessage(messages.layoutSelectStatus)}
          </option>
          <option value="approved">{formatMessage(messages.layoutApproved)}</option>
          <option value="rejected">{formatMessage(messages.layoutRejected)}</option>
        </select>
  
        <button onClick={handleStatusChange}>
          {formatMessage(messages.layoutUpdateStatus)}
        </button>
  
        <label>
          <input
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAll}
          />
          <span>{formatMessage(messages.layoutSelectAll)}</span>
        </label>
      </div>
  
      <ProgramCreationTable
        data={data}
        page={page}
        pageSize={pageSize}
        totalCount={totalCount}
        setPage={setPage}
        setPageSize={setPageSize}
        setSearch={setSearchTerm} // Pass setSearch from here
        selectedRows={selectedRows}  // Pass selectedRows to the child
        setSelectedRows={setSelectedRows}  // Pass setSelectedRows function to update selected rows in parent
      />
    </div>
  );
  
};

export default ApprovalsPage;
